module.exports = __webpack_public_path__ + "dcb18bf5c126491e34fcf839661559b9.gif";


//////////////////
// WEBPACK FOOTER
// ./components/bare_home/better.gif
// module id = 600
// module chunks = 0